import { LoanCriteria } from '@nemuru-eng/js-api-client';

export const getOrderCriteriaProcessStatus = (loan: LoanCriteria) => {
  return loan.status;
};
